<template>
  <div class="all">
    <div class="bommot">
      <ctar1></ctar1>
      <div class="left">
        <div class="leftbox1">
          <div class="leftb1" @mouseup="dian('con1')">
            <div id="con1">
              <div style="width: 100px; z-index: 999; position:absolute;color: black;">{{ vin1 }}</div>
            </div>
          </div>
          <div class="leftb1" @mouseup="dian('con2')">
            <div id="con2">
              <div style="width: 100px; z-index: 999; position:absolute;color: black;">{{ vin2 }}</div>
            </div>
          </div>
        </div>
        <div class="leftbox2">
          <div class="leftb1" @mouseup="dian('con3')">
            <div id="con3">
              <div style="width: 100px; z-index: 999; position:absolute;color: black;">{{ vin3 }}</div>
            </div>
          </div>
          <div class="leftb1" @mouseup="dian('con4')">
            <div id="con4">
              <div style="width: 100px; z-index: 999; position:absolute;color: black;">{{ vin4 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="right">
    <!-- <div class="right1"> -->
    <el-row>
      <el-col :span="18">
        <el-input v-model="filterText" placeholder="请输入组织名称" />
      </el-col>
      <el-col :span="4">
        <el-button type="primary">搜索</el-button>
      </el-col>
    </el-row>
    <div style="height: 83%">
      <el-scrollbar height="95%">
        <el-tree ref="treeRef" class="filter-tree" :data="tree_data" :props="defaultProps" node-key="value"
          :default-expanded-keys="launch" :filter-node-method="filterNode" @node-click="handleBucketClick" />
        <!-- </div> -->
        <div class="right2">
          <div style="
              width: 100%;
              height: 30px;
              background-color: #0063ae;
              display: flex;
                justify-content: flex-end;
              align-items: center;
            ">
            <RefreshRight color="blue" style="width: 2em; height: 2em; margin-right: 8px" @click="g_area_car_list()" />
          </div>
          <draggable v-model="car_list" chosen-class="chosen" force-fallback="true" group="site" :disabled="disabled"
            animation="600" @start="onStart" @end="onEnd" @add="add1">
            <template #item="{ element }">
              <div class="list-group-item" :class="{ 'not-draggable': !enabled }">
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <img :src="element.image" />
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="grid-content bg-purple-light">{{ element.vin }}</div>
                  </el-col>
                  <el-col :span="6">
                    <div @click="f_car(item)" class="grid-content bg-purple">
                      <div v-if="element.is_focus == '1'">
                        <img src="../../assets/img/icon_gz.png" />
                      </div>

                      <div v-else>
                        <img src="../../assets/img/icon_qxgz.png" />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
          </draggable>
        </div>
      </el-scrollbar>

      <div class="demo-pagination-block" style="margin-bottom: 20%">
        <el-pagination v-model:currentPage="currentPage3" :page-size="table_page.limit" layout="prev, pager, next"
          :total="table_page.sum" @current-change="handsize"></el-pagination>
      </div>
      <div class="bommot2">
        <div :class="backcolor[index]" v-for="(item, index) in listdata" :key="index">
          <div class="center">{{ item.num }}</div>
          <div class="center">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>   
<script>
let con1 = "";
let con2 = "";
let con3 = "";
let con4 = "";
let shijiantime1 = "";
let shijiantime2 = "";
let shijiantime3 = "";
let shijiantime4 = "";
let xpath1 = [];
let xpath2 = [];
let xpath3 = [];
let xpath4 = [];
let polyline1 = ''
let polyline2 = ''
let polyline3 = ''
let polyline4 = ''
let marker1 = ''
let marker2 = ''
let marker3 = ''
let marker4 = ''
let zuzhitime = ''
import { RefreshRight } from "@element-plus/icons";
import ctar1 from "../../components/ctar1.vue";
import carUrl from "../../assets/img/car.png";
import draggable from "vuedraggable";
import {
  get_area_list,
  get_area_all_car_info,
  get_area_car_list,
  focus_car,
  get_all_car_status,
  get_area_one_car_info
} from "../../api/car_manage/car_manage";
import { useStore } from "vuex";
import { reactive, onMounted, toRefs, onBeforeUnmount, ref, watch } from "vue";
import { clearInterval } from "timers";
let containerth = ""; //地图实例
export default {
  components: { ctar1, draggable, RefreshRight },
  name: "Four_cars",
  setup() {
    const data = reactive({
      input: "",
      value: "",
      value1: "",
      showtab: true,
      miao: "5",
      vin1: '',
      vin2: '',
      vin3: '',
      vin4: '',
      backcolor: ["child0", "child1", "child2", "child3", "child4"],
      ditu: "",
      car_list: "",
      table_page: {
        sum: 20,
        page: 1,
        limit: 10,
      },
      multipleSelection: [],
      listdata: "",
      area_name: "",
      area_id: "1",
      vin: '',
      tree_data: [],
      //定义要被拖拽对象的数组
      drag: false,
      //定义要被拖拽对象的数组
      car_info: "",
    });
    const Store = useStore();
    const filterText = ref('')
    const treeRef = ref('')

    const defaultProps = {
      children: 'children',
      label: 'label',
    }
    watch(filterText, (val) => {
      treeRef.value.filter(val)
    })
    const filterNode = (value, data) => {
      if (!value) return true
      return data.label.includes(value)
    }
    //区域车辆列表
    const g_area_car_list = () => {
      if (localStorage.getItem("selectTab_item") != "Four_cars") {
        localStorage.setItem("selectTab_item", "Four_cars");
      }
      Store.commit('gorouter', "Car_manage")
      get_area_car_list(
        data.table_page.page,
        data.table_page.limit,
        data.area_id
      ).then((res) => {
        data.car_list = res.data;
        data.table_page.sum = res.count;
      });
    };
    //关注
    const f_car = (row) => {
      let vin = row.vin;
      let focus = row.is_focus == 0 ? 1 : 0;
      focus_car(vin, focus).then((res) => {
        g_area_car_list();
        g_all_car_status();
      });
    };
    // 区域列表
    const g_area_list = () => {
      get_area_list(data.area_name).then((res) => {
        if (res.code === 0) {
          data.tree_data = [];
          data.tree_data.push(res.data);
          data.area_id = res.data.children[0].value
          g_area_car_list()
        }
      });
    };

    const handleBucketClick = (e) => {
      if (data.launch.indexOf(e.value) > -1) {
        // 大于 0 代表存在，
        data.launch.splice(data.launch.indexOf(e.value), 1) // 存在就删除
      } else {
        data.launch.push(e.value)
      }
      if (e.value != undefined) {
        data.area_id = e.value
        g_area_car_list()
      }
    }
    //渲染坐标
    const convertFrom = (path, type, icon, course) => {
      // 创建一个 Icon
      var startIcon = new AMap.Icon({
        // 图标尺寸
        // size: new AMap.Size(25, 34),
        // 图标的取图地址
        image: icon,
        // 图标所用图片大小
        imageSize: new AMap.Size(25, 30),
        // // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-9, -3)
      });
      AMap.convertFrom(path, type, function (status, result) {
        if (result.info === "ok") {
          var resLnglat = result.locations[0];
          let m2 = new AMap.Marker({
            position: resLnglat,
            icon: startIcon,
            angle: course,
          });
          containerth.add(m2);
        }
      });
    };
    //车辆状态
    const g_all_car_status = () => {
      get_all_car_status().then((res) => {
        data.listdata = res.data;
      });
    };
    const checkMove = (evt) => {
      return true;
    };
    //开始拖拽事件
    const onStart = (e) => {
      data.car_info = e.item._underlying_vm_;
      data.vin = data.car_info.vin
      data.drag = true;
    };
    //拖拽结束事件
    const onEnd = (e) => {
      data.drag = false;

    };
    //单车渲染

    const dian = (id) => {
      if (id == "con1" && data.car_info != "") {
        let vin = data.vin
        data.vin1 = data.vin
        con1 = new AMap.Map(id, {
          resizeEnable: true, //是否监控地图容器尺寸变化
          mapStyle: "amap://styles/normal",
          center: [118.017482, 36.803601],
          zoom: "18",
        });
        if (shijiantime1) {
          window.clearInterval(shijiantime1)
          con1.clearMap();
          xpath1 = []
        }
        shijiantime1 = setInterval(() => {
          get_area_one_car_info(vin).then((res) => {

            if (res.data.length != 0) {
              if (res.data[0].car_gps.length != 0 && res.data[0].car_gps[0].longitude != 0 && res.data[0].car_gps[0].latitude != 0) {
                let lnglat = [
                  res.data[0].car_gps[0].longitude,
                  res.data[0].car_gps[0].latitude];
                let icon = res.data[0].car_status_img;
                let type = res.data[0].gps_type;
                let course = res.data[0].car_gps[0].course;
                var startIcon = new AMap.Icon({
                  image: icon,
                  // 图标所用图片大小
                  imageSize: new AMap.Size(25, 30),
                });
                AMap.convertFrom(lnglat, type, function (status, result) {
                  if (result.info === "ok") {
                    var resLnglat = result.locations[0];
                    if (res.data[0].car_status != 0) {
                      if (marker1) {
                        marker1.setAngle(course);
                        marker1.setPosition([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      } else {
                        marker1 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                      }
                      marker1.setMap(con1);
                      // con1.setZoomAndCenter(18, );
                      con1.setCenter([
                        result.locations[0].lng,
                        result.locations[0].lat,
                      ]); //设置地图中心点
                      let zlnglat = [result.locations[0].lng, result.locations[0].lat]
                      xpath1.push(zlnglat);
            
                      let paths = xpath1.map((d) => {
                        return new AMap.LngLat(d[0], d[1]);
                      });

                      if (polyline1) {
                        //判断清空上一次的轨迹
                        con1.remove(polyline1);
                      }
                      polyline1 = new AMap.Polyline({
                        path: paths,
                        borderWeight: 2, // 线条宽度，默认为 1
                        strokeColor: "#3366FF", // 线条颜色
                        lineJoin: "round", // 折线拐点连接处样式
                      });
                      con1.add(polyline1);
                    } else {
                      if (marker1) {
                      } else {
                        marker1 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                        marker1.setMap(con1);
                        con1.setCenter([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      }
                    }
                  }
                });
              }
            }
          })
        }, 1000)
        data.car_info = "";
      } else if (id == "con2" && data.car_info != "") {
        data.vin2 = data.vin
        let vin2 = data.vin
        con2 = new AMap.Map(id, {
          resizeEnable: true, //是否监控地图容器尺寸变化
          mapStyle: "amap://styles/normal",
          zoom: "18",
          center: [118.017482, 36.803601],
        });
        if (shijiantime2) {
          window.clearInterval(shijiantime2)
          con2.clearMap();
          xpath2 = []
        }

        shijiantime2 = setInterval(() => {
          get_area_one_car_info(vin2).then((res) => {
            if (res.data.length != 0) {
              if (res.data[0].car_gps.length != 0 && res.data[0].car_gps[0].longitude != 0 && res.data[0].car_gps[0].latitude != 0) {
                let lnglat = [
                  res.data[0].car_gps[0].longitude,
                  res.data[0].car_gps[0].latitude];
                let icon = res.data[0].car_status_img;
                let type = res.data[0].gps_type;
                let course = res.data[0].car_gps[0].course;
                var startIcon = new AMap.Icon({
                  image: icon,
                  // 图标所用图片大小
                  imageSize: new AMap.Size(25, 30),
                });
                AMap.convertFrom(lnglat, type, function (status, result) {
                  if (result.info === "ok") {
                    var resLnglat = result.locations[0];
                    if (res.data[0].car_status != 0) {
                      if (marker2) {
                        marker2.setAngle(course);
                        marker2.setPosition([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      } else {
                        marker2 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                      }
                      marker2.setMap(con2);
                      con2.setCenter([
                        result.locations[0].lng,
                        result.locations[0].lat,
                      ]); //设置地图中心点
                      let zlnglat = [result.locations[0].lng, result.locations[0].lat]
                      xpath2.push(zlnglat);
                      let paths = xpath2.map((d) => {
                        return new AMap.LngLat(d[0], d[1]);
                      });
                      if (polyline2) {
                        //判断清空上一次的轨迹
                        con2.remove(polyline2);
                      }
                      polyline2 = new AMap.Polyline({
                        path: paths,
                        borderWeight: 2, // 线条宽度，默认为 1
                        strokeColor: "#3366FF", // 线条颜色
                        lineJoin: "round", // 折线拐点连接处样式
                      });
                      con2.add(polyline2);
                    } else {
                      if (marker2) {
                      } else {
                        marker2 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                        marker2.setMap(con2);
                        con2.setCenter([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      }
                    }
                  }
                });

              }
            }
          })
        }, 1000)
        data.car_info = "";
      } else if (id == "con3" && data.car_info != "") {
        let vin3 = data.vin
        data.vin3 = data.vin
        con3 = new AMap.Map(id, {
          resizeEnable: true, //是否监控地图容器尺寸变化
          mapStyle: "amap://styles/normal",
          zoom: "18",
          center: [118.017482, 36.803601],
        });
        if (shijiantime3) {
          window.clearInterval(shijiantime3)
          con3.clearMap();
          xpath3 = []
        }
        shijiantime3 = setInterval(() => {
          get_area_one_car_info(vin3).then((res) => {
            if (res.data.length != 0) {
              if (res.data[0].car_gps.length != 0 && res.data[0].car_gps[0].longitude != 0 && res.data[0].car_gps[0].latitude != 0) {
                let lnglat = [
                  res.data[0].car_gps[0].longitude,
                  res.data[0].car_gps[0].latitude];
                let icon = res.data[0].car_status_img;
                let type = res.data[0].gps_type;
                let course = res.data[0].car_gps[0].course;
                var startIcon = new AMap.Icon({
                  image: icon,
                  // 图标所用图片大小
                  imageSize: new AMap.Size(25, 30),
                });
                AMap.convertFrom(lnglat, type, function (status, result) {
                  if (result.info === "ok") {
                    var resLnglat = result.locations[0];
                    if (res.data[0].car_status != 0) {
                      if (marker3) {
                        marker3.setAngle(course);
                        marker3.setPosition([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      } else {
                        marker3 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                      }
                      marker3.setMap(con3);
                      con3.setCenter([
                        result.locations[0].lng,
                        result.locations[0].lat,
                      ]); //设置地图中心点
                      let zlnglat = [result.locations[0].lng, result.locations[0].lat]
                      xpath3.push(zlnglat);
                      let paths = xpath3.map((d) => {
                        return new AMap.LngLat(d[0], d[1]);
                      });
                      if (polyline3) {
                        //判断清空上一次的轨迹
                        con3.remove(polyline3);
                      }
                      polyline3 = new AMap.Polyline({
                        path: paths,
                        borderWeight: 2, // 线条宽度，默认为 1
                        strokeColor: "#3366FF", // 线条颜色
                        lineJoin: "round", // 折线拐点连接处样式
                      });
                      con3.add(polyline3);
                    } else {
                      if (marker3) {
                      } else {
                        marker3 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                        marker3.setMap(con3);
                        con3.setCenter([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      }
                    }
                  }
                });

              }
            }
          })
        }, 1000)
        data.car_info = "";
      } else if (id == "con4" && data.car_info != "") {
        let vin4 = data.vin
        data.vin4 = data.vin
        con4 = new AMap.Map(id, {
          resizeEnable: true, //是否监控地图容器尺寸变化
          mapStyle: "amap://styles/normal",
          zoom: "18",
          center: [118.017482, 36.803601],
        });
        if (shijiantime4) {
          window.clearInterval(shijiantime4)
          con4.clearMap();
          xpath4 = []
        }
        shijiantime4 = setInterval(() => {
          get_area_one_car_info(vin4).then((res) => {
            if (res.data.length != 0) {
              if (res.data[0].car_gps.length != 0 && res.data[0].car_gps[0].longitude != 0 && res.data[0].car_gps[0].latitude != 0) {
                let lnglat = [
                  res.data[0].car_gps[0].longitude,
                  res.data[0].car_gps[0].latitude];
                let icon = res.data[0].car_status_img;
                let type = res.data[0].gps_type;
                let course = res.data[0].car_gps[0].course;
                var startIcon = new AMap.Icon({
                  image: icon,
                  // 图标所用图片大小
                  imageSize: new AMap.Size(25, 30),
                });
                AMap.convertFrom(lnglat, type, function (status, result) {
                  if (result.info === "ok") {
                    var resLnglat = result.locations[0];
                    if (res.data[0].car_status != 0) {
                      if (marker4) {
                        marker4.setAngle(course);
                        marker4.setPosition([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                      } else {
                        marker4 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                      }
                      marker4.setMap(con4);
                      con4.setCenter([
                        result.locations[0].lng,
                        result.locations[0].lat,
                      ]); //设置地图中心点
                      let zlnglat = [result.locations[0].lng, result.locations[0].lat]
                      xpath4.push(zlnglat);
                      let paths = xpath4.map((d) => {
                        return new AMap.LngLat(d[0], d[1]);
                      });
                      if (polyline4) {
                        //判断清空上一次的轨迹
                        con4.remove(polyline4);
                      }
                      polyline4 = new AMap.Polyline({
                        path: paths,
                        borderWeight: 2, // 线条宽度，默认为 1
                        strokeColor: "#3366FF", // 线条颜色
                        lineJoin: "round", // 折线拐点连接处样式
                      });
                      con4.add(polyline4);
                    } else {
                      if (marker4) {
                      } else {
                        marker4 = new AMap.Marker({
                          icon: startIcon,
                          position: [result.locations[0].lng, result.locations[0].lat],
                          offset: new AMap.Pixel(-13, -30),
                          angle: course,
                        });
                        marker4.setMap(con4);
                        con4.setCenter([
                          result.locations[0].lng,
                          result.locations[0].lat,
                        ]);
                        // con4.setZoomAndCenter(18, [
                        //   result.locations[0].lng,
                        //   result.locations[0].lat,
                        // ]);
                      }
                    }
                  }
                });
              }
            }
          })
        }, 1000)
        data.car_info = "";
      }
    };
    g_area_list();
    g_area_car_list();
    g_all_car_status();
    onMounted(() => {

    });

    const handsize = (val) => {

      data.table_page.page = val;

      g_area_car_list();
    };
    zuzhitime = setInterval(() => {
      get_area_list(data.area_name).then((res) => {
        data.tree_data = [];
        data.tree_data.push(res.data);
      });
    }, 5000)
    // onBeforeUnmount(() => {
    //   //销毁地图
    //   if (zuzhitime) {
    //     window.clearInterval(zuzhitime)
    //   }
    //   if (con1 != "") {
    //     con1.destroy();
    //   }
    //   if (con2 != "") {
    //     con2.destroy();
    //   }
    //   if (con3 != "") {
    //     con3.destroy();
    //   }
    //   if (con4 != "") {
    //     con4.destroy();
    //   }
    //   if (shijiantime1) {
    //     window.clearInterval(shijiantime1)
    //   }
    //   if (shijiantime2) {
    //     window.clearInterval(shijiantime2)
    //   }
    //   if (shijiantime3) {
    //     window.clearInterval(shijiantime3)
    //   }
    //   if (shijiantime4) {
    //     window.clearInterval(shijiantime4)
    //   }

    // });
    return {
      ...toRefs(data),
      f_car,
      handsize,
      g_area_list,
      checkMove,
      onStart,
      onEnd,
      dian,
      handleBucketClick,
      defaultProps,
      filterNode,
      filterText,
      g_area_car_list,
      treeRef
    };
  },
};
</script>
<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/back.png");
  background-size: 100% 100%;
  position: relative;
}

.top_set {
  background-image: url("../../assets/img/top_set.png");
  width: 30%;
  height: 80%;
  background-size: 100% 100%;
}

.bommot {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;

  display: flex;
}

.el-menu {
  border: rgb(255, 255, 255);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

#container2 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

/deep/.amap-copyright {
  font-size: 0px;
}

/deep/.amap-logo img {
  height: 0px !important;
  width: 0px !important;
}

.el-row {
  color: #000;
  text-align: center;
  margin-top: 5px;
}

.bommot1 {
  background-color: #0063ae;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.right {
  width: 15%;
  height: 100%;
  position: absolute;
  background-color: rgb(255, 255, 255);
  right: 1%;
  top: 0%;
  z-index: 999;

  .right1 {
    height: 20%;
    background-color: rgb(255, 255, 255);
  }

  .right2 {
    height: 80%;
    font-size: 12px;
  }
}

.input {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 40px;
  height: 30px;
  font-size: 14px;
}

.sel {
  border-radius: 3px;
  height: 30px;
  font-size: 12px;
  width: 180px;
  color: #000;
  background-color: rgb(255, 255, 255);
}

.bommot2 {
  height: 8%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 0%;
  z-index: 99;
  font-size: 13px;
  color: #000;

  .child0 {
    height: 90%;
    width: 17%;
    background-color: #bae7ff;
    border-radius: 5px;
  }

  .child2 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #d9f7be;
  }

  .child3 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #eeeeee;
  }

  .child4 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffcdcd;
  }

  .child1 {
    height: 90%;
    width: 17%;
    border-radius: 5px;
    background-color: #ffe7ba;
  }
}

.center {
  display: flex;
  height: 50%;
  align-items: center;
  justify-content: center;
  color: #000;
}

.left {
  width: 80%;
  height: 100%;
}

.leftbox1 {
  width: 100%;
  height: 49%;
  display: flex;
  justify-content: space-between;
}

.leftbox2 {
  width: 100%;
  height: 49%;
  margin-top: 1%;
  display: flex;
  justify-content: space-between;
}

.leftb1 {
  width: 49.5%;
  height: 100%;
  background-color: rgba(20, 126, 224, 0.24);
}

/*被拖拽对象的样式*/
.list-group-item {
  color: black;
}

.item {
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  cursor: move;
}

.item:hover {
  background-color: #f1f1f1;
  cursor: move;
}

/*选中样式*/
// .chosen {
//   border: solid 2px #3089dc !important;
// }
#con1 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#con2 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#con3 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#con4 {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>